import Trip from '@/models/Trip'
import TripSteps from '@/models/TripSteps'

export default {
  props: {
    initialized: {
      type: Boolean,
      default: false
    },
    steps: {
      type: TripSteps,
      required: true
    },
    trip: {
      type: Trip,
      required: true
    }
  },
  computed: {
    /**
     * A user can see other travelers only if is signed in and he's a traveler
     * of that trip. For example, if the trip is public a user can see everything
     * but the travelers list
     *
     * @returns {Boolean}
     */
    canViewTravelers () {
      return this.$currentUser && this.trip.users[this.$currentUser.id]
    },

    /**
     * Check if a user can edit a trip
     *
     * @returns {Boolean}
     */
    canEdit () {
      if (this.$currentUser) {
        const role = this.trip.users[this.$currentUser.id]
        return role === 'owner' || role === 'editor'
      } else {
        return false
      }
    },

    tripId () {
      return this.$route.params.id
    }
  }
}
